module.exports = __webpack_public_path__ + "media/images/history/knopova2-01c9adf3f5daa256b78d4cf4afeb27d6.jpg";